import React, { useRef, useEffect, useState } from 'react';
import { motion, useScroll, useTransform } from "framer-motion";
import '../styles/BetPlace.css'; 

const BetPlaceSection = () => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  // Scroll progress and background animation
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });
  const backgroundY = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  // Check if element is in view
  const checkInView = (entries) => {
    const [entry] = entries;
    if (entry.isIntersecting) {
      setInView(true); // Set to true when in view
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(checkInView, {
      threshold: 0.5, // Adjust the threshold if needed
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <section ref={ref} className="BetPlace-section">

      <motion.div 
        className="BetPlace-bg" 
        style={{ 
          y: backgroundY, 
          backgroundImage: 'url("background3.webp")', 
          backgroundSize: 'cover', 
          backgroundPosition: 'center' 
        }} 
      />

      {/* Foreground Overlay */}
      <div className="BetPlace-overlay"></div>

      <div className="BetPlace-container">

        <motion.div 
          className="BetPlace-left"
          initial={{ x: '-100%' }}
          animate={inView ? { x: 0 } : {}}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <img src="cricket1.webp" alt="Cricket" className="cricket" />
        </motion.div>

        <motion.div 
          className="BetPlace-right"
          initial={{ x: '100%' }}
          animate={inView ? { x: 0 } : {}}
          transition={{ duration: 1, ease: "easeOut" }}
        >
          <h1 className="BetPlace-heading">
            How to place <br/><span>Your bet in our IDs</span>
          </h1>
          <p className="BetPlace-subtext">
            With Our Step-By-Step Guide For Beginners, Get Started Playing. Start Learning Now..<br/>24/7 ACTIVE.
          </p>
          <hr className="BetPlace-divider" />
          <p className="BetPlace-whatsapp-text">We Deal Only On WhatsApp</p>

          {/* WhatsApp Contact Buttons */}
          <div className="BetPlace-whatsapp-buttons">
          <a href={`https://wa.me/918949471009`} className="BetPlace-whatsapp-button">+44 7477 180422</a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default BetPlaceSection; 
